<template>
  <v-row class="table-row">
    <v-col class="pb-16" cols="12" sm="12" md="12">
      <v-data-table
        :headers="tableHeaders"
        :items="items"
        :items-per-page="pagination.per_page"
        :page.sync="pagination.page"
        @page-count="pagination.page_count = $event"
        class="elevation-1"
        hide-default-footer>

        <template v-slot:item.website="{ item }">
          {{ item.website }} 
          <v-icon 
            v-if="item.is_social_media === true" 
            color="orange"
            small 
            light> 
            mdi-account-multiple
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <download-banner v-if="item !== null" :banner="item"></download-banner>
          <copy-banner v-if="item !== null" :banner="item" @copied="showMessage = true; message='Copied URL!'"></copy-banner>
          <v-btn @click="updateShowPreviewModal(); preview(item)" small class="preview-btn white--text" outlined color="teal" >            
              <v-icon small dark> mdi-format-list-bulleted-square</v-icon>
              Preview
          </v-btn>
          <v-btn @click="deleteBanner(item.referral_code)" class="preview-btn white--text" outlined color="red" >            
              <v-icon small dark> mdi-delete</v-icon>
              Delete
          </v-btn>
        </template>

        <template v-slot:footer>
          <v-pagination
            ref="pagination"
            v-model="pagination.page"
            :length="pagination.page_count"
          ></v-pagination>
        </template>


      </v-data-table>
      <!-- <pagination class="pt-10" :pagination="pagination" @paginate="fetchArchivedBanners($event)"></pagination> -->
      <banner-preview-modal v-if="previewedBanner !== null" v-model="showPreviewModal" :banner="previewedBanner">
          <copy-banner :banner="previewedBanner" @copied="showMessage = true; message='Copied URL!'"></copy-banner>
          <download-banner :banner="previewedBanner"></download-banner>
      </banner-preview-modal>
      <banner-delete-modal 
        v-model="deleteModal"
        ref="bannerDeleteModalComponent"
        :open="deleteModal"
        @status="getDeleteStatus"
        >
      </banner-delete-modal>
      <v-snackbar v-model="showMessage" :timeout="2000" class="font-sm"> {{ message }} </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
import BannerPreviewModal from '@/components/affiliate-tools/BannerPreviewModal'
import CopyBanner from '@/components/affiliate-tools/CopyBanner'
import DownloadBanner from '@/components/affiliate-tools/DownloadBanner'
import BannerDeleteModal from '@/components/affiliate-tools/BannerDeleteModal'

import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: 'affiliateTools/getField',
  mutationType: 'affiliateTools/updateField',
})

export default {
  name: 'BannerArchive',
  components: { BannerPreviewModal, CopyBanner, DownloadBanner, BannerDeleteModal },
  props: ['value'],
  data: () => ({
    message: '',
    showMessage: false,
    deleteModal: false,
    tableHeaders: [
      {
        text: 'Campaign Name',
        align: 'start',
        value: 'campaign_name'
      },
      {
        text: 'Type',
        align: 'start',
        value: 'type'
      },
      {
        text: 'Language',
        align: 'start',
        value: 'language'
      },
      {
        text: 'Website',
        align: 'start',
        value: 'website'
      },
      {
        text: 'Referral Code',
        align: 'start',
        value: 'referral_code'
      },
      {
        text: 'Action',
        align: 'start',
        value: 'action'
      },
    ]
  }),
  mounted () {
    setTimeout(() => { this.$refs.pagination.onResize() }, 100)
    this.fetchArchivedBanners()
  },
  methods: {
    ...mapActions('affiliateTools', [
        'preview',
        'fetchArchivedBanners', 
        'updateShowPreviewModal',
      ]
    ),
    deleteBanner(referralCode) {
      this.$refs.bannerDeleteModalComponent.confirmation(true, referralCode)
    },
    getDeleteStatus(status) {
      this.fetchArchivedBanners();
      if (status === 'success') {
        this.$store.dispatch('affiliateTools/fetchArchivedBanners').then(() => {
          this.showMessage = true
          this.message = 'Banner successfully deleted.'
        })
      } else {
        this.showMessage = true
        this.message = 'Something went wrong. Please try agaian.'
      }
    }
  },
  computed: {
    ...mapGetters('affiliateTools', [ 'archivedBanners', 'previewedBanner']),
    ...mapFields(['showPreviewModal']),
    items () {
      return this.archivedBanners.data
    },
    pagination () {
      return this.archivedBanners.pagination
    },
  },
  watch: {
    items () {
      return this.archivedBanners.data
    },
    pagination () {
      return this.archivedBanners.pagination
    },
  }
}
</script>

<style scoped>
  .download-btn, .preview-btn, .copy-btn{   
      font-size: 10px !important;    
      margin: 10px;
  }
  .table-row{
    padding: 40px;;
  }
  @media screen and (max-width: 600px) {
    .download-btn, .preview-btn, .copy-btn{   
      width: 93px;
      margin-right: 0 !important;   
    }
  }
  @media screen and (max-width: 414px) {
    .download-btn, .preview-btn, .copy-btn{   
      width: 67px;
      font-size: 8px !important; 
    }
    .table-row{   
      padding-right: 20px;
      padding-left: 20px;
    }    
  }
</style>